export const ApiUrls = {
	getAllEventCategories: '/api/EventCategory/getList',
	getAllEventCategoryDetail: '/api/EventCategory/getById',
	insertEventCategory: '/api/EventCategory/insert',
	updateEventCategory: '/api/EventCategory/update',
	deleteEventCategory: '/api/EventCategory/delete',
	getEventCategory: '/eventCategory/getAllCategory',
	getRoles: '/api/User/getRoles',
	getRoleById: '/api/User/getRoleById',
	updateRole: '/api/User/updateRole',
	deleteRole: '/api/User/deleteRole',
	insertRole: '/api/User/createRole',
	getUsers: '/api/User/getList',
	getAllUserList: '/api/User/getAllUserList',
	getUsersWithoutInvitations: '/api/User/getUsersWithoutInvitations',
	getUser: '/api/User/getById',
	getUserNotification: '/api/User/GetUserNotification',
	updateUserNotification: '/api/User/updateUserNotification',
	updateCurrentUserProfile: '/api/User/updateCurrentUserProfile',
	getCurrentUserProfileImage: '/api/User/getCurrentUserProfileImage',
	getAllPermissions: '/api/User/getAllPermissions',
	insertUser: '/api/User/createUser',
	validateInvitedUser: '/api/UserInvitation/ValidateEmail',
	inviteUser: '/api/UserInvitation/InvitePeople',
	resendInvitationEmail: '/api/UserInvitation/ResendInvitationEmail',
	deleteInvitation: '/api/UserInvitation/delete',
	updateUser: '/api/User/update',
	deleteUser: '/api/User/delete',
	getUserPermissions: '/user/getAllPermissions',
	getUserPermission: '/user/getPermission',
	deleteUserPermission: '/user/deletePermission',
	getAllOrganizations: '/api/Organization/getList',
	getAllOrganizationsDetails: '/api/Organization/getById',
	updateOrganization: '/api/Organization/update',
	deleteOrganization: '/api/Organization/delete',
	insertOrganization: '/api/Organization/insert',
	getTournaments: '/api/Tournament/getList',
	getTournament: '/api/Tournament/getById',
	deleteTournament: '/api/Tournament/delete',
	insertTournament: '/api/Tournament/insert',
	updateTournament: '/api/Tournament/update',
	getPriceCategories: '/api/PriceCategory/getList',
	getPriceCategory: '/api/PriceCategory/getById',
	deletePriceCategory: '/api/PriceCategory/delete',
	insertPriceCategory: '/api/PriceCategory/insert',
	updatePriceCategory: '/api/PriceCategory/update',
	getEvents: '/api/Event/getList',
	getEvent: '/api/Event/getById',
	deleteEvent: '/api/Event/delete',
	insertEvent: '/api/Event/insert',
	updateEvent: '/api/Event/update',
	getSubEvents: '/api/SubEvent/getList',
	getSubEvent: '/api/SubEvent/getById',
	deleteSubEvent: '/api/SubEvent/delete',
	insertSubEvent: '/api/SubEvent/insert',
	updateSubEvent: '/api/SubEvent/update',
	getConfigTypes: '/api/ConfigurationType/getList',
	getConfigType: '/api/ConfigurationType/getById',
	deleteConfig: '/settings/deleteConfig',
	updateConfig: '/api/ConfigurationType/update',
	getLookups: '/settings/getAllLookups',
	getLookup: '/settings/getLookup',
	deleteLookup: '/settings/deleteLookup',
	getTemplates: '/api/Template/getList',
	getAllSelectedTemplates: '/api/Template/getAllSelectedTemplates',
	updateSelectedTemplate: '/api/Template/updateSelectedTemplate',
	getChipData: '/api/Template/getChipData',
	getTemplate: '/settings/getTemplate',
	deleteTemplate: '/api/Template/DeleteEmailTemplate',
	getBookings: '/api/Booking/getBookings',
	getBooking: '/booking/getBooking',
	deleteBooking: '/booking/deleteBooking',
	getPayments: '/payment/getAllPayments',
	getPayment: '/payment/getPayment',
	deletePayment: '/payment/deletePayment',
	login: '/api/Auth/login',
	loginsso: '/api/Auth/sso-login',
	refreshToken: '/api/Auth/refresh',
	verifyOtp: '/api/Auth/OTPVerify',
	resendLoginOtp: '/api/Auth/resend-login-otp',
	//forgotPassword: '/auth/forgotPassword',
	forgotPassword: '/api/Auth/ForgotPassword',
	verifyPasswordResetOtp1: '/api/Auth/verify-password-reset-otp1',
	setPasswordForReset: '/api/Auth/set-password-for-reset',
	completePasswordReset: '/api/Auth/complete-password-reset',
	completePasswordResetByToken: '/api/Auth/complete-password-reset-by-token',
	changePassword: '/api/Auth/ChangePassword',
	resetPassword: '/api/Auth/ResetPassword',
	getUserLoginPermissions: '/api/Auth/getUserPermissions',
	signupUser: '/api/UserInvitation/SignupUser',
	passwordOtp: '/api/Auth/OTPVerify',
	getAllVenues: '/api/VenueDetails/getList',
	getVenueDetails: '/api/VenueDetails/getById',
	deleteVenue: '/api/VenueDetails/delete',
	insertVenue: '/api/VenueDetails/insert',
	updateVenue: '/api/VenueDetails/update',
	getAllBlocks: '/api/BlockDetails/getList',
	deleteBlock: '/api/BlockDetails/delete',
	getEnums: '/api/Enum/getList',
	deleteEnum: '/api/Enum/delete',
	insertEnum: '/api/Enum/insert',
	updateEnum: '/api/Enum/update',
	getEnumById: '/api/Enum/getById',
	getEnumItems: '/api/Enum/getEnumItemList',
	insertBlock: '/api/BlockDetails/insert',
	updateBlock: '/api/BlockDetails/update',
	getBlockDetails: '/api/BlockDetails/getById',
	getSeatMapping: '/api/VenueSeatMapping/getList',
	insertBlockSeatMapper: '/api/VenueSeatMapping/insert',
	updateBlockSeatMapper: '/api/VenueSeatMapping/update',
	getLangList: "/api/Language/getList",
	createSeatMapping: '/api/EventSeatsMapping/insert',
	updateSeatMapping: '/api/EventSeatsMapping/update',
	createUpdateSeatMapping: '/api/EventSeatsMapping/InsertOrUpdate',
	getEventSeatMapping: '/api/EventSeatsMapping/getList',
	deleteEventSeatMapping: '/api/EventSeatsMapping/delete',
	insertImage: '/api/ImageManager/InsertImage',
	updateImage: '/api/ImageManager/UpdateImage',
	getImageById: '/api/ImageManager/getById',
	deleteImage: '/api/ImageManager/delete',
	getImageList: '/api/ImageManager/getList',
	getImage: '/api/ImageManager/GetImage',
	createMailTemplate: '/api/Template/CreateEmailTemplate',
	updateMailTemplate: '/api/Template/UpdateEmailTemplate',
	getMailTemplateById: '/api/Template/getById',
	getContentTemplates: '/api/ContentTemplate/getList',
	getContentTemplateById: '/api/ContentTemplate/getById',
	createContentTemplate: '/api/ContentTemplate/Create',
	updateContentTemplate: '/api/ContentTemplate/Update',
	deleteContentTemplate: '/api/ContentTemplate/Delete',
	getSignatures: '/api/Signature/getList',
	getSignatureById: '/api/Signature/getById',
	getSignatureByManagerId: '/api/Signature/getSignatureByMangerId',
	createSignature: '/api/Signature/Create',
	updateSignature: '/api/Signature/Update',
	deleteSignature: '/api/Signature/Delete',
	getAllTicketTemplate: '/api/TicketTemplate/getList',
	createTicketTemplate: '/api/TicketTemplate/insert',
	updateTicketTemplate: '/api/TicketTemplate/update',
	getTicketTemplateById: '/api/TicketTemplate/getById',
	insertFaq: '/api/Faq/insert',
	deleteFaq: '/api/Faq/delete',
	updateFaq: '/api/Faq/update',
	getFaqById: '/api/Faq/getById',
	getFaqList: '/api/Faq/GetFaqList',
	getAllApplication: '/api/CustomerApplication/GetList',
	updateApplicationStatus: '/api/CustomerApplicationStatus/UpdateApplicationStatus',
	getEventCountStatus: '/api/Event/getEventsCountByStatus',
	getBookingCount: '/api/Booking/getBookingCount',
	createCategory: '/api/Category/create',
	categoryGetList: '/api/Category/getList',
	categoryById: '/api/Category/getById',
	updateCategory: '/api/Category/update',
	deleteCategory: '/api/Category/delete',
	createWorkflowGroup: '/api/WorkflowGroup/create',
	updateWorkflowGroup: '/api/WorkflowGroup/update',
	getWorkFlowGroupById: '/api/WorkflowGroup/getById',
	workflowGroupList: '/api/WorkflowGroup/getList',
	deleteWorkflowGroup: '/api/WorkflowGroup/delete',
	workFlowList: '/api/Workflow/getList',
	workflowDetailsGroupList: '/api/WorkFlowGroups/GetAllWorkFlowGroups',
	workflowDetailsCategoryList: '/api/Category/GetAllCategory',
	worflowDetailsGetById: '/api/WorkFlowDetails/getByCategoryId',
	getWorkflowById: '/api/Workflow/getById',
	createWorkflow: '/api/Workflow/create',//'/api/WorkFlowDetails/create',
	updateWorkflow: '/api/Workflow/update',
	deleteWorkflow: '/api/Workflow/delete',
	workflowActionInbox: '/api/WorkflowAction/inbox',
	workflowActionOutbox: '/api/WorkflowAction/outbox',
	workflowActionProcess: '/api/WorkflowAction/processAction',
	workflowActionManagerList: '/api/WorkflowAction/getManagerList',
	workflowActionGetLog: '/api/WorkflowAction/getLog',
	createLookUp: '/api/Lookup/CreateLookupItemAsync',
	updateLookUp: '/api/Lookup/UpdateLookupItemAsync',
	getLookUpByParentId: '/api/Lookup/GetLookupItemByParentIdAsync',
	getLookupById: '/api/Lookup/GetLookupItemByIdAsync',
	getLookupItems: '/api/Lookup/GetLookupItemsAsync',
	GetParticipationTypesLookUp: '/api/Lookup/GetParticipationTypesLookUp',
	deleteLookupItems: '/api/Lookup/DeleteLookupItemAsync',
	getDelegations: '/api/Delegation/getList',
	createDelegations: '/api/Delegation/create',
	getDelegationById: '/api/Delegation/getById',
	UpdateDelegations: '/api/Delegation/update',
	DeleteDelegations: '/api/Delegation/delete',
	RevokeDelegations: '/api/Delegation/revoke',
	getDelegationPermission: '/api/Delegation/permissions',
	assignDelegationPermission: '/api/Delegation/assignPermission',
	removeDelegationPermission: '/api/Delegation/removePermission',
	getAllDelegatablePermissions: '/api/User/GetAllDelegatablePermissions',
	userDelegations: '/api/Delegation/userDelegations',
	getAdministrationList: '/api/Administration/getList',
	createAdministration: '/api/Administration/createAdministration',
	getAdministrationById: '/api/Administration/getById',
	updateAdministration: '/api/Administration/updateAdministration',
	deleteAdministration: '/api/Administration/deleteAdministration',
	getDepartmentList: '/api/Department/getList',
	lookupTypeGetList: '/api/LookupType/getList',
	lookupTypeGetById: '/api/LookupType/getById',
	lookupTypeCreate: '/api/LookupType/createLookupType',
	lookupTypeUpdate: '/api/LookupType/updateLookupType',
	lookupTypeDelete: '/api/LookupType/deleteLookupType',
	lookupItemGetList: '/api/LookupItem/getList',
	lookupItemGetById: '/api/LookupItem/getById',
	lookupItemGetByLookupTypeId: '/api/LookupItem/getByLookupTypeId',
	lookupItemCreate: '/api/LookupItem/createLookupItem',
	lookupItemUpdate: '/api/LookupItem/updateLookupItem',
	lookupItemDelete: '/api/LookupItem/deleteLookupItem',
	getEventList:'/api/Event/getList',
	getWorkflowByDepartment: '/api/WorkFlowDetails/getByDepartment',
	getusersbydept: '/api/User/getUserByDepartment',
	getusersbydepts: '/api/User/getUsersByDepartments',
	getDepartmentUserStorageStats: '/api/User/getDepartmentUserStorageStats',
	exportDepartmentUserDetails: '/api/User/exportDepartmentUserDetails',
	getUserByRoleAndDepartment: '/api/User/getUserByRoleAndDepartment',
	getDepartmentByLoggedInUser: '/api/Department/getDepartmentByLoggedInUser',
	createDepartment: '/api/Department/createDepartment',
	getDepartmentById: '/api/Department/getById',
	getDepartmentStorageOverview: '/api/Department/getStorageOverview',
	updateDepartment: '/api/Department/updateDepartment',
	deleteDepartment: '/api/Department/deleteDepartment',
	documentCategoryGetList: '/api/DocumentCategory/getList',
	getDocumentCategoryById: '/api/DocumentCategory/getById',
	createDocumentCategory: '/api/DocumentCategory/createDocumentCategory',
	updateDocumentCategory: '/api/DocumentCategory/updateDocumentCategory',
	deleteDocumentCategory: '/api/DocumentCategory/deleteDocumentCategory',
	getDepartmentFolderHierarchyConfigByDept: '/api/DepartmentFolderHierarchyConfig/getByDepartment',
	saveDepartmentFolderHierarchyConfig: '/api/DepartmentFolderHierarchyConfig/save',
	getEmailConfiguration: '/api/EmailConfiguration/getEmailConfiguration',
	updateEmailConfiguration: '/api/EmailConfiguration/updateEmailConfiguration',
	getTasksMeetings: '/api/Meeting/GetTasksMeetings',
	gettaskStatusLookup: '/api/Lookup/GetTaskStatusLookUp',
	sendTasks: '/api/Document/SaveSharedRecommendations',
	sharedUserRec: '/api/Document/GetSharedRecDetails',
	deleteRecommendation: '/api/Document/DeleteSharedRecommendations',
	updateRecommenation: '/api/Meeting/UpdateRecommendations',
	createPomReportTemplate: '/api/Template/createUpdateParticipantReportTemplate',
	getAllParticipantReportTemplate: '/api/Template/getAllParticipantReportTemplate',
	getAllSelectedTemplate: '/api/Template/getAllSelectedParticipantReportTemplate',
	UpdateSelectedPRTemplate: '/api/Template/UpdateSelectedPRTemplate',
	downloadTemplate: '/api/Template/downloadTemplate',
	createTranslationTemplate: '/api/Template/createUpdateTranslationTemplate',
	getAllTranslationTemplate: '/api/Template/getAllTranslationTemplate',
	deleteTranslationTemplate: '/api/Template/deleteTranslationTemplate',
	deleteParticipantReportTemplate: '/api/Template/deleteParticipantReportTemplate',
	getAllSelectedTranslationTemplate: '/api/Template/getAllSelectedTranslationTemplate',
	UpdateSelectedTranslationTemplate: '/api/Template/UpdateSelectedTranslationTemplate',
	GetAllConfiguration: '/api/SchedulerConfiguration/getConfigurationList',
	GetConfigurationByCode: '/api/SchedulerConfiguration/getConfiguration',
	CreateConfiguration: '/api/SchedulerConfiguration/createConfiguration',
	UpdateConfiguration: '/api/SchedulerConfiguration/updateConfiguration',
	DeleteConfiguration: '/api/SchedulerConfiguration/deleteConfiguration',
	GetPrecedentAllDocuments: '/api/Document/GetAllDocument',
	GetPrecedentDocumentDetails: '/api/PrecedentDashboard/GetDocumentDetails',
	GetPrecedentDashboardCounts: '/api/PrecedentDashboard/GetPrecedentDashboardCounts',
	GetStatusCounts: '/api/PrecedentDashboard/GetDocumentStatusCount',
	GetPrecedentCategoryTwoCounts: '/api/PrecedentDashboard/GetPrecedentCategoryTwoCounts',
	GetParticipationMinutesPerDep: '/api/PrecedentDashboard/GetParticipationMinutesPerDep',
	GetParticipantNamesPerDep: '/api/PrecedentDashboard/GetParticipantNamesPerDep',
	GetRecommendationsCount: '/api/PrecedentDashboard/GetRecommendationsCount',
	organizationalHierarchy: '/api/Lookup/GetLookUpHierarchy',
	CallAiOnApproval: '/api/Ai/CallAiOnApproval',
	SearchAndAnswerAi: '/api/Ai/SearchAndAnswerAi',
	SearchAi: '/api/Ai/SearchAi',
	DeleteAi: '/api/Ai/DeleteAi',
	updateSubjectWithLevels: '/api/Lookup/UpdateSubjectWithLevels',
	getConfidentialityLookupItems: '/api/Lookup/GetConfidentialityLookUp',
	getDelegationToken: '/api/Auth/delegation-token',
	FilterDropDownValues: '/api/PrecedentDashboard/GetPrecedentDashboardFilterDropDownValues',
	ExportPrecedentDashboardData: '/api/PrecedentDashboard/ExportPrecedentDashboardData',
	GetRecommendationDetails: "/api/PrecedentDashboard/GetRecommendationDetails",
	GetPrecedentCategoryTwoMonthlyCounts: "/api/PrecedentDashboard/GetPrecedentCategoryTwoMonthlyCounts",
	DownloadReport: "/api/PrecedentDashboard/ExportPrecedentDashboardData",
	GetDocumentWorkFlowDetails: "/api/PrecedentDashboard/GetDocumentWorkFlowDetails",
	getGetDocumentPomDetails: "/api/PrecedentDashboard/GetDocumentPomDetails",
	GetDashboardSubject: '/api/PrecedentDashboard/GetDashboardSubject',
	GetDashboardTwoCounts: '/api/DashboardTwo/GetDashboardTwoCounts',
	GetDashboardTwoRecommendationsCount: '/api/DashboardTwo/GetRecommendationsCount',
	GetDashboardTwoParticipantNamesPerDep: '/api/DashboardTwo/GetParticipantNamesPerDep',
	GetDashboardTwoPrecedentCategoryTwoCounts: '/api/DashboardTwo/GetPrecedentCategoryTwoCounts',
	GetDashboardTwoStatusCounts: '/api/DashboardTwo/GetDocumentStatusCount',
	GetDashboardTwoRecommendationDetails: '/api/DashboardTwo/GetRecommendationDetails',
	GetDashboardTwoDocumentDetails: '/api/DashboardTwo/GetDocumentDetails',
	GetDashboardTwoDocumentPomDetails: '/api/DashboardTwo/GetDocumentPomDetails',
	GetDashboardTwoDocumentWorkFlowDetails: '/api/DashboardTwo/GetDocumentWorkFlowDetails',
	GetDashboardTwoParticipationMinutesPerDep: '/api/DashboardTwo/GetParticipationMinutesPerDep',
	GetDashboardTwoPrecedentCategoryTwoMonthlyCounts: '/api/DashboardTwo/GetPrecedentCategoryTwoMonthlyCounts',
	GetDashboardTwoFilterDropDownValues: '/api/DashboardTwo/GetDashboardTwoFilterDropDownValues',
	GetDashboardTwoDashboardSubject: '/api/DashboardTwo/GetDashboardSubject',
	ExportDashboardTwoPrecedentDashboardData: '/api/DashboardTwo/ExportPrecedentDashboardData',
	GetDashboardTwoParticipantPerDocument: '/api/DashboardTwo/GetDashboardTwoParticipantPerDocument',
	GetDashboardThreeParticipantPerDocument: '/api/DashboardThree/GetDashboardThreeParticipantPerDocument',
	GetDashboardThreeCounts: '/api/DashboardThree/GetDashboardThreeCounts',
	GetDashboardThreeRecommendationsCount: '/api/DashboardThree/GetDashboardThreeRecommendationsCount',
	GetDashboardThreeParticipantNamesPerDep: '/api/DashboardThree/GetDashboardThreeParticipantNamesPerDep',
	GetDashboardThreePrecedentCategoryTwoCounts: '/api/DashboardThree/GetDashboardThreePrecedentCategoryTwoCounts',
	GetDashboardThreeStatusCount: '/api/DashboardThree/GetDashboardThreeStatusCount',
	GetDashboardThreeRecommendationDetails: '/api/DashboardThree/GetDashboardThreeRecommendationDetails',
	GetDashboardThreeDocumentDetails: '/api/DashboardThree/GetDashboardThreeDocumentDetails',
	GetDashboardThreeDocumentPomDetails: '/api/DashboardThree/GetDashboardThreeDocumentPomDetails',
	GetDashboardThreeDocumentWorkFlowDetails: '/api/DashboardThree/GetDashboardThreeDocumentWorkFlowDetails',
	GetDashboardThreeParticipationMinutesPerDep: '/api/DashboardThree/GetDashboardThreeParticipationMinutesPerDep',
	GetDashboardThreePrecedentCategoryTwoMonthlyCounts: '/api/DashboardThree/GetDashboardThreePrecedentCategoryTwoMonthlyCounts',
	GetDashboardThreePrecedentDashboardFilterDropDownValues: '/api/DashboardThree/GetDashboardThreePrecedentDashboardFilterDropDownValues',
	GetDashboardThreeSubject: '/api/DashboardThree/GetDashboardThreeSubject',
	ExportDashboardThreeData: '/api/DashboardThree/ExportDashboardThreeData',
	GetDashboardThreeDocumentCountPerEmployee: '/api/DashboardThree/GetDashboardThreeDocumentCountPerEmployee',
	GetCountDashboardThreeEmployeeResponsibleTranslations: '/api/DashboardThree/GetCountDashboardThreeEmployeeResponsibleTranslations',
	ExportDashboardThreeDocumentWorkFlowDetails: '/api/DashboardThree/ExportDashboardThreeDocumentWorkFlowDetails',
	getAllLookUps: '/api/Lookup/getList',
	createNewLookup: '/api/Lookup/createLookUp',
	updateLookUpName: '/api/Lookup/updateLookUp',
	getLookUpByID: '/api/Lookup/getById',
	deleteLookUp: '/api/Lookup/deleteLookUP',
	lookupDetailsById: '/api/Lookup/GetLookupDetailsByLookupId',
	ceateLookupDetails: '/api/Lookup/createLookUpDetails ',
	getLookupdetailsById: '/api/Lookup/getLookupdetailsById',
	updateLookUpDetails: '/api/Lookup/updateLookUpDetails',
	deleteLookUpDetails: '/api/Lookup/deleteLookUpDetails',
	resetPasswordByToken:'/api/Auth/reset-password-by-token',
	validateResetToken:'/api/Auth/validate-reset-token',
	getApplicationConfiguration: '/api/ApplicationConfiguration/getList',
	getApplicationConfigurationById: (id: number) => `/api/ApplicationConfiguration/getById/${id}`,
	getAllowedUploadTypes: '/api/ApplicationConfiguration/fileType',
	getAllowedFileTypesList: '/api/ApplicationConfiguration/getAllowedFileTypesList',
	getAllowedFileTypesById: (id: number | string) => `/api/ApplicationConfiguration/getAllowedFileTypesById/${id}`,
	createAllowedFileTypes: '/api/ApplicationConfiguration/createAllowedFileTypes',
	updateAllowedFileTypes: '/api/ApplicationConfiguration/updateAllowedFileTypes',
	deleteAllowedFileTypes: (id: number | string) => `/api/ApplicationConfiguration/deleteAllowedFileTypes/${id}`,
	createApplicationConfiguration: '/api/ApplicationConfiguration/create',
	updateApplicationConfiguration: (id: number) => `/api/ApplicationConfiguration/update/${id}`,
	deleteApplicationConfiguration: '/api/ApplicationConfiguration/delete',
	activateDeactivateUser: (userId: number,actOrdeact:string) => `/api/User/${actOrdeact}/${userId}`,
	sendInvite:'/api/UserInvitation/SendInvite',
	registerUser:'/api/UserInvitation/Register',
	verifyRegistrationOtp:'/api/UserInvitation/VerifyRegistrationOtp',
	resendRegistrationOtp:'/api/UserInvitation/ResendRegistrationOtp',
	validateRegisterCode:'/api/UserInvitation/CheckCode',
	validateShareToken: (token: string) => `/api/Share/validate-token?token=${token}`,
	processShareLink: (token: string) => `/api/Share/process-link?token=${token}`

}
